// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JO3S","title":"_169ec","description":"_3WLi1","descriptionText":"_1O25X"};